module.exports = __webpack_public_path__ + "static/media/main_logo_white.73c5a676.png";